import React, { useCallback, useState } from 'react';

import PageSubheader from '~/components/Common/Elements/PageSubheader';

import { useExtractStopsellDates } from '~/hooks/apis/stopsell/useExtractStopsellDates';

import { CatalogRoom, StopsellExtractionResult } from '~/types/stopsell';

import StopsellDocumentUploadZone from './StopsellDocumentUploadZone';
import StopsellReviewModal from './StopsellReviewModal';

interface Props {
  catalogRooms?: Array<CatalogRoom>;
}

export default function StopsellManagementPane({ catalogRooms = [] }: Props) {
  const { mutate, isPending, error } = useExtractStopsellDates();
  const [extractionResult, setExtractionResult] = useState<StopsellExtractionResult | null>(null);
  const [fileName, setFileName] = useState<string>('');
  const [reviewOpen, setReviewOpen] = useState(false);

  const handleSelectFile = useCallback(
    (file: File) => {
      setFileName(file.name);
      mutate(
        { file, catalogRooms },
        {
          onSuccess: (data: StopsellExtractionResult) => {
            setExtractionResult(data);
            setReviewOpen(true);
          },
        },
      );
    },
    [mutate, catalogRooms],
  );

  // TODO: XTRNT-576 — submit selected stopsell dates to the API
  const handleApply = useCallback((_selected: StopsellExtractionResult) => {
    setReviewOpen(false);
  }, []);

  return (
    <>
      <PageSubheader title="Stopsell Management" />
      <StopsellDocumentUploadZone onSelectFile={handleSelectFile} isPending={isPending} error={error?.message} />

      {extractionResult && (
        <StopsellReviewModal
          open={reviewOpen}
          onClose={() => setReviewOpen(false)}
          onApply={handleApply}
          extraction={extractionResult}
          fileName={fileName}
          catalogRooms={catalogRooms}
        />
      )}
    </>
  );
}
